module.exports = __webpack_public_path__ + "img/member_cards_icon_431003.77de6150.jpg";